import { Tool } from '../Tool';

/**
 * {@link PanTool} is a marker {@link Tool} that activates pan-on-left-click.\
 * When active, {@link ToolManager} configures the global {@link PanAction}
 * to accept both left (0) and middle (1) mouse buttons, so all panning
 * routes through a single action with proper cancel/restart on mouse-leave.
 */
export class PanTool extends Tool {
    public readonly toolType = 'pan';
}
